import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_itinerary_close_sider",
  "use": "icon_itinerary_close_sider-usage",
  "viewBox": "0 0 18.899 15.33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.899 15.33\" id=\"icon_itinerary_close_sider\"><defs><style>#icon_itinerary_close_sider .a{fill:none;stroke:#716f80;stroke-linecap:round;stroke-width:2px;}</style></defs><g transform=\"translate(-21.049 -13.475)\"><path class=\"a\" d=\"M9190.116,29.363h15.942\" transform=\"translate(-9167.11 -8.265)\" /><path class=\"a\" d=\"M9195.714,21.889l-6.251,6.251,6.251,6.251\" transform=\"translate(-9167 -7)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol